import React from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, unit, icon: Icon, color, trend, delay = 0 }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.4 }}
      className="bg-white rounded-xl shadow-sm p-5 border border-gray-100 hover:shadow-md transition-all hover:scale-[1.02]"
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm text-gray-500 font-medium">{title}</p>
          <p className="text-3xl font-bold mt-1 text-gray-800">
            {value}<span className="text-lg font-normal text-gray-400 ml-1">{unit}</span>
          </p>
          {trend && (
            <p className="text-xs mt-2 flex items-center gap-1">
              <span className={trend > 0 ? "text-red-500" : "text-green-500"}>
                {trend > 0 ? `+${trend}` : `${trend}`}% from last week
              </span>
            </p>
          )}
        </div>
        <div className={`p-3 rounded-xl ${color}`}>
          <Icon size={22} className="text-white" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;